import type { AuthContextValue } from "@/contexts/AuthContext";

/**
 * platform_owner + platform_dev may queue bug reports for IDE sync-and-fix.
 *
 * Uses `realHasRole` (not `hasRole`) so the user's actual platform identity
 * gates this — impersonation should not strip access to dev-sync from a real
 * `platform_dev` user who is testing as a sales rep. See dev-sync note
 * 91847507-ebf5-429b-8192-db1b4234c029.
 */
export function canQueueDevSyncNotes(auth: AuthContextValue | null | undefined): boolean {
  if (!auth || auth.status !== "ready") return false;
  return auth.realHasRole("platform_owner", "platform_dev");
}

export function isPlatformOwnerForDevSync(auth: AuthContextValue | null | undefined): boolean {
  if (!auth || auth.status !== "ready") return false;
  return auth.realHasRole("platform_owner");
}
